import { render, staticRenderFns } from "./CreateOrEditAdminForum.vue?vue&type=template&id=664f6dba&scoped=true&"
import script from "./CreateOrEditAdminForum.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditAdminForum.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditAdminForum.vue?vue&type=style&index=0&id=664f6dba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f6dba",
  null
  
)

export default component.exports